var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfidIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 24 24",
    height: 512,
    fill: "white",
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.75 24h-13.5c-1.241 0-2.25-1.009-2.25-2.25v-10.5c0-1.241 1.009-2.25 2.25-2.25h13.5c1.241 0 2.25 1.009 2.25 2.25v10.5c0 1.241-1.009 2.25-2.25 2.25zm-13.5-13.5c-.414 0-.75.336-.75.75v10.5c0 .414.336.75.75.75h13.5c.414 0 .75-.336.75-.75v-10.5c0-.414-.336-.75-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.25 10.5c-.414 0-.75-.336-.75-.75v-3.75c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5v3.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3.75c0-3.309 2.691-6 6-6s6 2.691 6 6v3.75c0 .414-.336.75-.75.75z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.12 18.38c-.192 0-.384-.073-.53-.22-.852-.852-2.328-.852-3.18 0-.293.293-.768.293-1.061 0s-.293-.768 0-1.061c1.418-1.418 3.883-1.418 5.301 0 .293.293.293.768 0 1.061-.146.147-.338.22-.53.22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.89 16.11c-.192 0-.384-.073-.53-.22-.897-.896-2.09-1.39-3.36-1.39s-2.463.494-3.36 1.39c-.293.293-.768.293-1.061 0s-.293-.768 0-1.061c1.181-1.179 2.751-1.829 4.421-1.829s3.24.65 4.42 1.83c.293.292.293.768 0 1.061-.146.146-.338.219-.53.219z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidIcon);
export default __webpack_public_path__ + "static/media/rfidIcon.cd3cf943eecbd9ac4ba717f61cf14138.svg";
export { ForwardRef as ReactComponent };